import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Row, Col, Popover, Modal } from 'antd'
import DocumentView from '../document-view/DocumentView'
import VideoView from '../assets-view/VideoView'
import { resumeDownload } from '../../actions/DownloadAction'
import CollectionMiddleView from './CollectionMiddleView'
import { setSelectItem, unsetSelectItem } from '../../actions/ClientAction'
import { showPermissionModal } from '../../actions/PermissionAction'
import ContextMenu from '../context-menu/ContextMenu'
import { getImageAssettByExtension, getWithDrawer, getNewPermission, getDeletePermissionName, IMAGE_EXT } from '../../utils'
import DownloadAsset from '../assets-download/DownloadAsset'
import { setKeyCollection, setkeyboardEnabled } from '../../actions/AppAction'
import fileextension from 'file-extension'
import { SVGView } from '../assets-view/SVGView'
import CustomCheckSelector from "../custom-check-selector/CustomCheckSelector";
import { updateModalVisibility, addItemSelect } from "../../actions/MultiselectAction";
import { individualSelectItem} from "../../actions/IndividualSelectAction";

const rowStyle = {
  padding: '16px',
  color: '#000',
  border: '0.5px solid',
  borderColor: '#e8e8e8'
}

const firstColumnStyle = {
  height: '70px',
  // borderRight: '0.5px solid',
  // borderRightColor: '#e8e8e8',
  padding: '19px',
  paddingLeft: "45px",
  display: 'flex',
  alignContent: 'center',
  cursor: 'pointer',
}
const lastColumnsStyle = {
  height: '70px',
  // borderRight: '0.5px solid',
  // borderRightColor: '#e8e8e8',
  padding: '19px',
  display: 'flex',
  alignContent: 'center',
  cursor: 'pointer',
}

const bunkerDescriptionColumn = {
  height: '70px',
  borderLeft: '0.5px solid',
  borderLeftColor: '#e8e8e8',
  padding: '19px',
  display: 'flex',
  alignContent: 'center',
  cursor: 'pointer'
}

export class CollectionList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      keepTypeColumn: null,
      assetNameLength: null,
      rootAssetColumnSpan: null,
      assetColumnSpan: null,
      rootNameColumnSpan: null,
      nameColumnSpan: null,
      showDownloadDrawer: false,
      itemSelectedState: null,
      canConvertionFolder: false,
      canDownload: true,
      canShare: true,
      canDelete: true,
      canEdit: true,
      canAddFavorite: true,
      canMove: true,
      canPermissions: true,
      canTagsProtocol: true,
      canCommentsAndVersions: false,
      canCreateVersionDart: false,
      canViewVersionsDart: false,
      canBunkeyHost: false,
      canShareLinkBunkeyHost: false
    }
  }

  componentDidMount() {
    const { 
      screenWidth,
      user,
      keyCollection,
      newMatrix,
      // folderselect
      itemSelected
    } = this.props

    if (keyCollection === 'assetsPublicShared') {
      this.setState({
        canDownload: true,
        canShare: false,
        canDelete: false,
        canEdit: false,
        canAddFavorite: false,
        canMove: false,
        canPermissions: false,
        canCommentsAndVersions: false,
        canCreateVersionDart: false,
        canViewVersionsDart: false,
        canBunkeyHost: false,
        canShareLinkBunkeyHost: false,
        canTagsProtocol: false
      })
    } else if (user.clientRole !== 'admin' && user.role !== 'admin' && itemSelected) {
      this.setState({
        canDownload: getNewPermission(itemSelected._id, newMatrix, "download"),
        canEdit: getNewPermission(itemSelected._id, newMatrix, 'edit'),
        canDelete: getNewPermission(itemSelected._id, newMatrix, 'delete'),
        canShare: getNewPermission(itemSelected._id, newMatrix, 'share'),
        canMove: getNewPermission(itemSelected._id, newMatrix, 'move'),
      })
    }

    if (screenWidth <= 768) {
      this.setState({
        keepTypeColumn: false,
        assetNameLength: 10,
        assetColumnSpan: 12,
        nameColumnSpan: 12,
        rootAssetColumnSpan: 12,
        rootNameColumnSpan: 12,
        // canConvertionFolder: (user.clientRole === 'admin' && user.role === 'admin' && (user.email === 'jorge@bunkey.tv' || user.email === 'victor@bunkey.tv' || user.email === 'ricardo.melo@bunkey.tv' || user.email === 'sebastian.grob@bunkey.tv'))
        canConvertionFolder: (user && user.clientRole === 'admin' && user.role === 'admin' && (user.email === 'jorge@bunkey.tv' || user.email === 'victor@bunkey.tv')),
      })
    } else {
      this.setState({
        keepTypeColumn: true,
        assetNameLength: 55,
        assetColumnSpan: 6,
        nameColumnSpan: 12,
        rootAssetColumnSpan: 4,
        rootNameColumnSpan: 8,
        canConvertionFolder: (user && user.clientRole === 'admin' && user.role === 'admin' && (user.email === 'jorge@bunkey.tv' || user.email === 'victor@bunkey.tv' || user.email === 'ricardo.melo@bunkey.tv' || user.email === 'sebastian.grob@bunkey.tv'))
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { screenWidth } = this.props

    if (prevProps.screenWidth !== screenWidth && screenWidth <= 768) {
      this.setState({
        keepTypeColumn: false,
        assetNameLength: 10,
        assetColumnSpan: 12,
        nameColumnSpan: 12,
        rootAssetColumnSpan: 12,
        rootNameColumnSpan: 12
      })
    } else if (prevProps.screenWidth !== screenWidth && screenWidth >= 768) {
      this.setState({
        keepTypeColumn: true,
        assetNameLength: 55,
        assetColumnSpan: 6,
        nameColumnSpan: 12,
        rootAssetColumnSpan: 4,
        rootNameColumnSpan: 8
      })
    }
  }

  handleMiddleView = r => {
    const { keyCollection, indice, from } = this.props

    if (r.isSelected === true) {
      this.props.unsetSelectItem(keyCollection)
    } else {
      this.props.setSelectItem(keyCollection, r, from, indice)
    }
  }

  handleSetSrc = r => {
    const { originalURL, lowQualityURL } = r;
    const itemUrl = (originalURL !== lowQualityURL) ? lowQualityURL : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  }

  handleShowDownloadDrawer = r => {
    this.setState({
      showDownloadDrawer: true,
      itemSelectedState: r
    })
  }

  handleShowMoveModal = r => {
    this.props.individualSelectItem(r, "move", this.props.keyCollection)
  };

  handleHideDownloadDrawer = () => {
    this.setState({ showDownloadDrawer: false })
    this.props.setkeyboardEnabled(false)
  }

  handleShowModalMultiShare = r => {
    const {keyCollection, addItemSelect, updateModalVisibility} = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiShare: true
    });
  };

  handleShowModalMultiDelete = r => {
    const {keyCollection, addItemSelect, updateModalVisibility} = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiDelete: true
    });
  };

  handleShowModalMultiMove = r => {
    const {keyCollection, addItemSelect, updateModalVisibility} = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiMove: true
    });
  };

  handleShowModalMultiDownload = r => {
    const {keyCollection, addItemSelect, updateModalVisibility} = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiDownload: true
    });
  };

  handleShowTagProtocolModal = r => {
    this.props.individualSelectItem(r, "tag_protocol", this.props.keyCollection);
  };

  handleShowGroup = r => {
    this.props.individualSelectItem(r, "group")
  };
  handleShowDeleteModal = r => {
    this.props.individualSelectItem(r, "delete", this.props.keyCollection)
  };

  handleShowShareModal = r => {
    this.props.individualSelectItem(r, "share", this.props.keyCollection)
  };

  handleGetPermissionFileOrFolder = (item_id, newMatrix, permission ) => {
    const {
      user,
      keyCollection
    } = this.props;
    if (keyCollection === "assetsPublicShared") {
      if (permission === "download") {
        return true
      } else {
        return false
      }
    } else {
      if (user.clientRole !== "admin" && user.role !== "admin") {
        return getNewPermission(item_id, newMatrix, permission)
      } else {
        return true;
      }
    }
  }
  render() {
    const { data, keyCollection, indice, newColor, intl, isHover, newMatrix } = this.props
    const {
      keepTypeColumn,
      assetNameLength,
      assetColumnSpan,
      rootAssetColumnSpan,
      nameColumnSpan,
      rootNameColumnSpan,
      showDownloadDrawer,
      itemSelectedState,
      canConvertionFolder,
      // canDownload,
      // canDelete,
      // canShare,
      // canMove,
      // canEdit,
      canTagsProtocol
    } = this.state

    let cont = 0
    const assetRoot = keyCollection === 'assetsRoot'
    const assetSpan = assetRoot ? rootAssetColumnSpan : assetColumnSpan
    const nameSpan = assetRoot ? rootNameColumnSpan : nameColumnSpan


    return (
      <div className="" style={{ width: '100%' }} >
        {data && data.length !== 0 && <Row style={{ backgroundColor: '#fafafa' }}>
          <Col span={nameSpan} style={rowStyle}>
            {/* Nombre */}
            {intl.formatMessage({ id: "name" })}
          </Col>
          {(assetRoot && keepTypeColumn) && <Col span={8} style={rowStyle}>
            {/* Descripción */}
            {intl.formatMessage({ id: "post_description" })}
          </Col>}
          <Col span={assetSpan} style={rowStyle}>
            Asset
          </Col>
          {keepTypeColumn && <Col span={assetRoot ? 4 : 6} style={rowStyle}>
            {/* Tipo */}
            {intl.formatMessage({ id: "type" })}
          </Col>}
        </Row>}

        {data && data.map((r, k) => {
          k++
          if (r.type === 'folder' || r.type === 'bunker') {
            cont++
            if (cont > 8) cont = 1
          }

          return <React.Fragment key = {k}>
            <ContextMenu keyCollection={keyCollection} key={k}
              item={r}
              menuItem={[{
                event: () => {
                  this.props.showPermissionModal(r)
                  this.props.setKeyCollection(keyCollection)
                  this.handleShowGroup(r)
                },
                icon: 'safety-certificate',
                text: intl.formatMessage({ id: "groups" })
              },
              // canDownload
              this.handleGetPermissionFileOrFolder(r._id, newMatrix, "download")
                ? {
                  event: () => r.type === 'folder' || r.type === 'bunker'
                    ? this.props.resumeDownload(r._id)
                    : this.handleShowModalMultiDownload(r),
                  icon: 'cloud-download',
                  text: intl.formatMessage({ id: "download_asset" })
                }
                : null,
              // canEdit 
              this.handleGetPermissionFileOrFolder(r._id, newMatrix, "edit")
                ? {
                  event: () => r.type === 'folder' || r.type === 'bunker'
                    ? this.props.resumeDownload(r._id)
                    : this.handleShowDownloadDrawer(r),
                  icon: 'edit',
                  text: intl.formatMessage({
                    id: "rename_asset"
                  })
                } : null,
              // canMove
              this.handleGetPermissionFileOrFolder(r._id, newMatrix, "move")
                ? {
                  event: () => this.handleShowMoveModal(r),
                  icon: 'logout',
                  text: intl.formatMessage({
                    id: "move_asset"
                  })
                } : null,
              canTagsProtocol &&
                (r.type === "folder" || r.type === "bunker") ? {
                  event: () => this.handleShowTagProtocolModal(r),
                  icon: 'tags',
                  text: 'Protocolos de tags'
                } : null,
              // canShare 
              this.handleGetPermissionFileOrFolder(r._id, newMatrix, "share")
                ? {
                  event: () => this.handleShowShareModal(r),
                  icon: 'share-alt',
                  text: intl.formatMessage({
                    id: "shared_share"
                  })
                } : null,
              // canDelete
              this.handleGetPermissionFileOrFolder(r._id, newMatrix, getDeletePermissionName(r.type))
                ? {
                  event: () => this.handleShowDeleteModal(r),
                  icon: 'delete',
                  text: 'Eliminar'
                } : null ,
              canConvertionFolder && (r.type === 'folder' || r.type === 'bunker') ? {
                event: () => {
                  this.props.convertionFolder(r._id)
                },
                icon: 'rocket',
                text: intl.formatMessage({ id: "convetinator_force_conversion" })
              }
                : null]}>
                <Row
                  style={{
                    heigth: '100px',
                    border: '0.1px solid',
                    borderColor: '#e8e8e8',
                    borderTopColor: '#fff'
                  }}
                  key={k}>

                  {/* Columna de Nombre de Asset */}
                  {r.type !== 'folder' && r.type !== 'bunker' && <Col
                    span={nameSpan}
                    onClick={() => this.handleMiddleView(r)}
                    onMouseEnter={() => this.props.handleOnMouseEnter(`list-${k}`)}
                    onMouseLeave={() => this.props.handleOnMouseLeave(`list-${k}`)}
                    style={firstColumnStyle} >
                    {r.name.length > assetNameLength ?
                      <Popover content={r.name} placement="bottom" > {r.name.slice(0, assetNameLength)}...</Popover>
                      : r.name}
                  </Col>}
                  {/* Columna de Nombre de Carpeta */}
                  {(r.type === 'folder' || r.type === 'bunker') && <Col
                    span={nameSpan}
                    onMouseEnter={() => this.props.handleOnMouseEnter(`list-${k}`)}
                    onMouseLeave={() => this.props.handleOnMouseLeave(`list-${k}`)}
                    onClick={() => this.props.handleOnClickExplore(r._id, r.name)}
                    style={firstColumnStyle} >
                    {r.name.length > assetNameLength ? <Popover content={r.name} placement="bottom">{r.name.slice(0, assetNameLength)}...</Popover> : r.name}
                  </Col>}

                  {/* Columna extra para descripción de Bunkers */}
                  {(assetRoot && keepTypeColumn) && r.type === 'bunker' && <Col
                    span={8}
                    onClick={() => this.props.handleOnClickExplore(r._id, r.name)}
                    style={bunkerDescriptionColumn}>
                    {r.longDescription && r.longDescription.length > 40 ? <Popover content={r.longDescription} placement="bottom">{r.longDescription.slice(0, 40)}...</Popover> : r.longDescription}
                  </Col>}

                  {/* Columna de Vista Previa de Asset */}
                  {r.type !== 'folder' && r.type !== 'bunker' && <Col
                    onClick={() => this.handleMiddleView(r)}
                    onMouseEnter={() => this.props.handleOnMouseEnter(`list-${k}`)}
                    onMouseLeave={() => this.props.handleOnMouseLeave(`list-${k}`)}
                    span={assetSpan}
                    style={{
                      cursor: 'pointer',
                      minHeight: '70px',
                      borderRight: '0.5px solid',
                      borderRightColor: '#e8e8e8',
                      borderLeft: '0.5px solid',
                      borderLeftColor: '#e8e8e8',
                      display: 'flex',
                      alignItems: 'center'
                    }} >
                    {r.type === 'image' && fileextension(r.originalURL) === 'svg' &&
                      <SVGView assetId={r._id} src={r.originalURL} />
                    }
                    {r.type === 'image' && 
                      fileextension(r.originalURL) !== 'svg' && 
                      IMAGE_EXT.includes(fileextension(r.originalURL)) && <img
                      indice={indice}
                      from={`list`}
                      src={this.handleSetSrc(r)}
                      alt={r.name}
                      style={{
                        cursor: 'pointer',
                        width: 'auto',
                        height: 'auto',
                        maxWidth: '90px',
                        maxHeight: '50px',
                        marginLeft: '10px'
                        
                      }}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src="/images/extensions/image.png";
                        currentTarget.className="img-asset-list-error";
                      }}
                    />}
                    {r.type === 'image' && 
                      fileextension(r.originalURL) !== 'svg' &&
                      !IMAGE_EXT.includes(fileextension(r.originalURL)) && (
                        <DocumentView
                          from={`horizontal`}
                          keyCollection={keyCollection}
                          indice={indice}
                          item={r}
                          className="img-asset"
                        />
                    )}
                    {r.type === 'video' && <VideoView
                      url={r.lowQualityURL}
                      isHoverPlay={true}
                      disableDefaultControls={true}
                      muted={true}
                      from={`list`}
                      r={r}
                      indice={indice}
                      keyCollection={keyCollection}
                    />}
                    {r.type === 'document' &&
                      <DocumentView
                        from={`list`}
                        keyCollection={keyCollection}
                        indice={indice}
                        item={r}
                      />}
                      {r.type === 'font' &&
                      <DocumentView
                        from={`list`}
                        keyCollection={keyCollection}
                        indice={indice}
                        item={r}
                      />}
                      {r.type === 'audio' &&
                      <DocumentView
                        from={`list`}
                        keyCollection={keyCollection}
                        indice={indice}
                        item={r}
                      />}
                      {r.type === 'other' &&
                      <DocumentView
                        from={`list`}
                        keyCollection={keyCollection}
                        indice={indice}
                        item={r}
                      />}
                  </Col>}

                  {/* Columna de Vista Previa de Carpeta */}
                  {(r.type === 'folder' || r.type === 'bunker') &&
                    <Col
                      onClick={() => this.props.handleOnClickExplore(r._id, r.name)}
                      span={assetSpan}
                      style={{
                        cursor: 'pointer',
                        height: '70px',
                        borderRight: '0.5px solid',
                        borderRightColor: '#e8e8e8',
                        display: 'flex',
                        alignItems: 'center',
                        borderLeft: '0.5px solid',
                        borderLeftColor: '#e8e8e8',
                      }} >
                      {/* Tipo Subcarpeta */}
                      {(r.type === 'folder') && <div
                        className={`hand color-${cont}`}
                        onClick={() => this.props.handleOnClickExplore(r._id, r.name)}
                        style={{
                          cursor: 'pointer',
                          padding: '7px',
                          backgroundColor: newColor ? newColor : '#2E97CF',
                          width: '95px',
                          height: '50px',
                          marginLeft: '10px',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                        }}><span> {r.name.length > 7 ? `${r.name.slice(0, 7)}...` : r.name}</span></div>}
                      {/* Tipo Bunker (con Popover) */}
                      {(r.type === 'bunker') && <div
                        className={`hand color-${cont}`}
                        onClick={() => this.props.handleOnClickExplore(r._id, r.name)}
                        style={{
                          cursor: 'pointer',
                          padding: '7px',
                          backgroundColor: newColor ? newColor : '#2E97CF',
                          width: '95px',
                          height: '50px',
                          marginLeft: '10px',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                        <span> {r.name.length > 7 ? `${r.name.slice(0, 7)}...` : r.name}</span>
                      </div>}
                    </Col>
                  }

                  {/* Columna de Tipo */}
                  {/* Tipo 'Mis Bunkers' assetRoot */}
                  {(assetRoot && keepTypeColumn) && (r.type === 'folder' || r.type === 'bunker') && <Col
                    span={4}
                    onClick={() => this.props.handleOnClickExplore(r._id, r.name)}
                    style={lastColumnsStyle}>
                    {r.type === 'bunker' && 'Bunker'}
                  </Col>}
                  {/* Tipo de carpetas !assetRoot  */}
                  {!assetRoot && keepTypeColumn && (r.type === 'folder' || r.type === 'bunker') && <Col
                    span={assetRoot ? 4 : 6}
                    onClick={() => this.props.handleOnClickExplore(r._id, r.name)}
                    style={lastColumnsStyle}>
                    {(r.parents.length > 1 && r.type === 'folder') && 'Subcarpeta'}
                    {r.parents.length === 1 && 'Bunker'}
                  </Col>}
                  {/* Tipo de Asset */}
                  {(keepTypeColumn) && r.type !== 'folder' && r.type !== 'bunker' && <Col
                    span={assetRoot ? 4 : 6}
                    onMouseEnter={() => this.props.handleOnMouseEnter(`list-${k}`)}
                    onMouseLeave={() => this.props.handleOnMouseLeave(`list-${k}`)}
                    onClick={() => this.handleMiddleView(r)}
                    style={lastColumnsStyle}>
                    {r.type === 'image' && intl.formatMessage({ id: "searche_tooltip_image" })}
                    {r.type === 'video' && intl.formatMessage({ id: "searche_tooltip_video" })}
                    {r.type === 'document' && intl.formatMessage({ id: "document" })}
                    {r.type === 'audio' && intl.formatMessage({ id: "files-audios" })}
                    {r.type === 'font' && intl.formatMessage({ id: "files-fonts" })}
                    {r.type === 'other' && intl.formatMessage({ id: "files-others" })}              
                  </Col>}

                  {/* Vista Media */}
                  {r.isSelected && <CollectionMiddleView from={`list`} keyCollection={keyCollection} />}
                  {keyCollection !== "assetsPublicShared" && <CustomCheckSelector
                    isHover={isHover}
                    k={k}
                    indice={indice}
                    itemHover={r}
                    hoverDetail={null}
                    keyCollection={keyCollection}
                    from={`list`}
                    inList
                    handleOnMouseEnter={() => this.props.handleOnMouseEnter(`list-${k}`)}
                    handleOnMouseLeave={() => this.props.handleOnMouseLeave(`list-${k}`)}
                  />}
                </Row>
            </ContextMenu>
          </React.Fragment>
          
        })}
        <Modal
          title={intl.formatMessage({ id: "download_asset" })}
          closable={true}
          width={getWithDrawer()}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHideDownloadDrawer}
          onClose={this.handleHideDownloadDrawer}
          visible={showDownloadDrawer}>
          <DownloadAsset
            itemSelected={itemSelectedState}
            handleHideDownloadDrawer={this.handleHideDownloadDrawer}
          // showIconExclamation={true}
          />
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps
  let object
  switch (keyCollection) {
    case 'assetsRoot':
      object = {
        data: state.assetsRoot.data,
        error: state.assetsRoot.error,
        itemSelected: state.assetsRoot.data.find(r => r.isSelected),
        folderselect: state.assetsRoot.folderselect,
      }
      break
    case 'assetsLastUploads':
      object = {
        data: state.assetsLastUploads.data,
        error: state.assetsLastUploads.error,
        itemSelected: state.assetsLastUploads.data.find(r => r.isSelected),
        folderselect: state.assetsLastUploads.folderselect,
      }
      break
    case 'assetsShared':
      object = {
        data: state.assetsShared.data,
        error: state.assetsShared.error,
        itemSelected: state.assetsShared.data.find(r => r.isSelected),
        folderselect: state.assetsShared.folderselect,
      }
      break
    case 'assetsFavorites':
      object = {
        data: state.assetsFavorites.data,
        error: state.assetsFavorites.error,
        itemSelected: state.assetsFavorites.data.find(r => r.isSelected),
        folderselect: state.assetsFavorites.folderselect,
      }
      break
    case 'assetsExplore':
      object = {
        data: state.assetsExplore.data,
        error: state.assetsExplore.error,
        itemSelected: state.assetsExplore.data.find(r => r.isSelected),
        folderselect: state.assetsExplore.folderselect,
      }
      break
    case 'searcher':
      object = {
        data: state.searcher.data,
        error: state.searcher.error,
        itemSelected: state.searcher.data.find(r => r.isSelected),
        folderselect: state.searcher.folderselect,
      }
      break
    case 'assetsPublicShared':
      object = {
        data: state.assetsPublicShared.data,
        error: state.assetsPublicShared.error,
        itemSelected: state.assetsPublicShared.data.find(r => r.isSelected),
        folderselect: state.assetsPublicShared.folderselect,
      }
      break

    default:
      object = {}
      break
  }

  return {
    ...object,
    screenWidth: state.app.width,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isDownloading: state.downloads.isDownloading,
    user: state.authUser.user,
    matrix: state.group.matrix,
    newMatrix: state.group.newMatrix,
  }
}

const mapDispatchToProps = {
  unsetSelectItem,
  setSelectItem,
  showPermissionModal,
  setKeyCollection,
  resumeDownload,
  setkeyboardEnabled,
  updateModalVisibility,
  addItemSelect,
  individualSelectItem
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionList)))
